import type { ReactNode } from 'react'
import { BrandMark, ThemeToggle } from '@clari/ui'
import { LanguageSwitcher } from '@/components/LanguageSwitcher'

/** Centered shell for unauthenticated screens (light by default per CHARTE §3). */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-bg text-text">
      <header className="flex items-center justify-between px-4 py-4 sm:px-6">
        <BrandMark size={22} />
        <div className="flex items-center gap-2">
          <LanguageSwitcher />
          <ThemeToggle defaultMode="light" />
        </div>
      </header>
      <main className="flex flex-1 items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">{children}</div>
      </main>
    </div>
  )
}
